import { useNavigate } from "react-router-dom";
import { ProductGrid } from "../product";
import { SEO } from "../SEO";

export function HipHopSection({ products, isPage }) {
  const navigate = useNavigate();
  const hiphopProducts = products.filter(p => p.collection === "Hip Hop");
  
  const taglines = [
    "Legends Never Die. Neither Do We.",
    "From the Block to the Top.",
    "Real Recognize Real.",
    "Culture Runs Deep."
  ];
  
  return (
    <section className={`py-20 px-4 ${isPage ? 'pt-32' : ''} bg-gradient-to-b from-black via-red-950/20 to-black`} data-testid="hiphop-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          {isPage && <SEO title="Hip Hop Collection" description="Fresh Po'Boy Hip Hop Legends Collection. Rap culture streetwear - Tupac, Biggie, Nipsey & more. Premium tees & hoodies." path="/hiphop" />}
          <span className="text-red-500 text-sm tracking-widest uppercase">Urban Legends</span>
          <h2 className="text-white text-5xl sm:text-6xl font-bebas mt-2">Hip Hop <span className="text-red-500">Collection</span></h2>
          <p className="text-white/60 mt-4 max-w-xl mx-auto">Pay homage to the legends. Urban streetwear celebrating hip hop culture.</p>
        </div>
        
        {isPage && (
          <div className="mb-16">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-5xl mx-auto">
              {taglines.map((tagline, index) => (
                <div 
                  key={tagline} 
                  className="p-4 rounded-xl bg-red-600/10 border border-red-600/30 text-center"
                >
                  <p className="text-sm sm:text-base font-bold text-red-500">
                    "{tagline}"
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
        
        <ProductGrid products={hiphopProducts} />
        {!isPage && hiphopProducts.length > 0 && (
          <div className="text-center mt-12">
            <button onClick={() => navigate('/hiphop')} className="px-8 py-4 bg-red-600 text-white font-semibold hover:bg-red-500 transition-colors" data-testid="view-hiphop-collection-btn">View Full Collection</button>
          </div>
        )}
      </div>
    </section>
  );
}
